// This file was auto-generated by Fern from our API Definition.
/** Derived from the inputs/data × force matrix. */
export const CommandMode = {
    Send: "send",
    Steer: "steer",
    Cancel: "cancel",
    Attach: "attach",
};
